export function installationDateToString(
    value: Date | string | null | undefined
): string | null {
    if (!value) {
        return null;
    }

    if (typeof value === 'string') {
        const normalized = normalizeDateString(value);
        if (normalized) {
            return normalized;
        }

        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) {
            return null;
        }

        value = parsed;
    }

    if (Number.isNaN(value.getTime())) {
        return null;
    }

    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function installationDateFromString(
    value: string | null | undefined
): Date | null {
    if (!value) {
        return null;
    }

    const normalized = normalizeDateString(value);
    if (normalized) {
        const [year, month, day] = normalized.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }

    return new Date(
        parsed.getFullYear(),
        parsed.getMonth(),
        parsed.getDate()
    );
}

function normalizeDateString(value: string): string | null {
    const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) {
        return null;
    }

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(year, month - 1, day);

    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return null;
    }

    return `${match[1]}-${match[2]}-${match[3]}`;
}
